import React from "react";
import { Typography } from "@mui/material";

import { Say } from "../../../../../arc/locale/consts.js";
import { BlimpMuiFormSection } from "../../../../elements/BlimpMuiFormSection/BlimpMuiFormSection";
import { Locale } from "../../../../assets/Locale.js";

export const UnsubscribeCategory = (props)=>{
    const { category } = props;
    const say = Locale.use();
    if (!category) { return null; }

    const Icon = category.icon;
    const fieldId = (...parts)=>Say.id("profile", "mailMe", "field", category.name, ...parts);

    return (
        <BlimpMuiFormSection bodyClassName="UnsubscribeForm-category" icon={Icon} title={say("profileUnsubscribeCategory")}>
            <Typography className="UnsubscribeForm-categoryLabel">{say(fieldId("label"))}</Typography>
            <Typography className="UnsubscribeForm-categorySummary">{say(fieldId("summary"))}</Typography>
        </BlimpMuiFormSection>
    );
};
